import { ProductDetailTab } from '@features/product-detail/types.ts';
import { useRouter } from '@tanstack/react-router';

export const useProductModal = () => {
  const router = useRouter();

  const openModal = (productId: number, selectedTab?: ProductDetailTab) => {
    router.navigate({
      // @ts-ignore
      search: s => ({ ...s, productId: productId, selectedTab: selectedTab }),
      state: s => ({ ...s, doNotRefresh: true }),
    });
  };

  const closeModal = () => {
    router.navigate({
      // @ts-ignore
      search: s => ({ ...s, productId: undefined, selectedTab: undefined }),
      state: s => ({ ...s, doNotRefresh: true }),
    });
  };
  return {
    openModal,
    closeModal,
  };
};
